"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Locales = void 0;
var Locales;
(function (Locales) {
    Locales["FR"] = "fr-FR";
    Locales["FR_CA"] = "fr-CA";
    Locales["ES"] = "es-ES";
    Locales["US"] = "en-US";
    Locales["EN_CA"] = "en-CA";
})(Locales || (exports.Locales = Locales = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90eXBlcy9sb2NhbGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksT0FNWDtBQU5ELFdBQVksT0FBTztJQUNqQix1QkFBWSxDQUFBO0lBQ1osMEJBQWUsQ0FBQTtJQUNmLHVCQUFZLENBQUE7SUFDWix1QkFBWSxDQUFBO0lBQ1osMEJBQWUsQ0FBQTtBQUNqQixDQUFDLEVBTlcsT0FBTyx1QkFBUCxPQUFPLFFBTWxCIn0=